module.exports = __webpack_public_path__ + "static/frontUserNew/media/new_order.db9ec583.wav";